import React from 'react'
import { Grid } from '@material-ui/core'
import { components } from 'cng-web-lib'
import { useFormContext } from 'react-hook-form'
import { PARTY_TYPE, PARTY_ID_TYPE } from '../Common/constants/entityOptions'
import { COUNTRY_OPTIONS } from '../Common/constants/country'
import SearchableCountryField from '../Common/components/SearchableCountryField'

const {
  form: {
    field: { CngTextField, CngSelectField }
  },
  CngGridItem
} = components

const DEFAULT_INITIAL_VALUES = {
  partyType: '',
  partyIdentificationType: '',
  partyName: '',
  address1: '',
  address2: '',
  address3: '',
  city: '',
  country: '',
  contactInfo: []
}

const FORMIK_PROPS = {
  initialValues: { ...DEFAULT_INITIAL_VALUES }
}

function Fields({ disabled }) {
  const { watch } = useFormContext()
  const partyType = watch('partyType') || ''
  const isShipperConsignee = partyType === 'CZ' || partyType === 'CN'
  return (
    <Grid container spacing={2}>
      <CngGridItem xs={12} sm={6} md={4}>
        <CngSelectField
          required
          name='partyType'
          label='Party Type'
          disabled={disabled}
          size='small'
          items={PARTY_TYPE}
        />
      </CngGridItem>
      <CngGridItem xs={12} sm={6} md={4}>
        <CngSelectField
          required
          name='partyIdentificationType'
          label='Party Identification Type'
          disabled={disabled}
          size='small'
          items={PARTY_ID_TYPE}
        />
      </CngGridItem>
      <CngGridItem xs={12} sm={6} md={4}>
        <CngTextField
          required
          name='partyName'
          label='Party name'
          disabled={disabled}
          inputProps={{ maxLength: 70 }}
          size='small'
        />
      </CngGridItem>
      <CngGridItem xs={12} sm={6} md={4}>
        <CngTextField
          required
          name='address1'
          label='Address 1'
          disabled={disabled}
          inputProps={{ maxLength: 256 }}
          size='small'
        />
      </CngGridItem>
      <CngGridItem xs={12} sm={6} md={4}>
        <CngTextField
          name='address2'
          label='Address 2'
          disabled={disabled}
          inputProps={{ maxLength: 256 }}
          size='small'
        />
      </CngGridItem>
      <CngGridItem xs={12} sm={6} md={4}>
        <CngTextField
          name='address3'
          label='Address 3'
          disabled={disabled}
          inputProps={{ maxLength: 256 }}
          size='small'
        />
      </CngGridItem>
      <CngGridItem xs={12} sm={6} md={4}>
        <CngTextField
          required={isShipperConsignee}
          name='city'
          label='City'
          disabled={disabled}
          inputProps={{ maxLength: 35 }}
          size='small'
        />
      </CngGridItem>
      <CngGridItem xs={12} sm={6} md={4}>
        <SearchableCountryField
          required={isShipperConsignee}
          name='country'
          label='Country'
          disabled={disabled}
        />
      </CngGridItem>

    </Grid>
  )
}

function toClientDataFormat(serverData) {
  return {
    ...serverData,
    partyType: serverData.partyType || '',
    partyIdentificationType: serverData.partyIdentificationType || '',
    partyName: serverData.partyName || '',
    address1: serverData.street || '',
    address2: serverData.streetNumber || '',
    address3: serverData.postalCode || '',
    city: serverData.city || '',
    country: serverData.country || '',
    contactInfo: (serverData.contactInfo || []).map(c => ({
      id: c.id,
      contactLevel: c.contactLevel || '',
      contactName: c.contactName || '',
      telephoneNumber: c.telephoneNumber || '',
      emailId: c.emailId || '',
      url: c.url || ''
    }))
  }
}

function toServerDataFormat(localData) {
  const { address1, address2, address3, ...rest } = localData
  return {
    ...rest,
    street: address1 || '',
    streetNumber: address2 || '',
    postalCode: address3 || ''
  }
}

const FormProperties = {
  formikProps: FORMIK_PROPS,
  Fields,
  toClientDataFormat,
  toServerDataFormat
}

export default FormProperties
